var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "language",
    transform: "translate(-243 -129)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_627",
    "data-name": "Rectangle 627",
    width: 48,
    height: 48,
    rx: 4,
    transform: "translate(243 129)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "language_black_24dp",
    transform: "translate(253 139)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2491",
    "data-name": "Path 2491",
    d: "M0,0H28V28H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2492",
    "data-name": "Path 2492",
    d: "M13.655,2A11.667,11.667,0,1,0,25.333,13.667,11.661,11.661,0,0,0,13.655,2ZM21.74,9H18.3a18.257,18.257,0,0,0-1.61-4.153A9.368,9.368,0,0,1,21.74,9ZM13.667,4.38A16.435,16.435,0,0,1,15.9,9H11.438A16.435,16.435,0,0,1,13.667,4.38ZM4.637,16a9.126,9.126,0,0,1,0-4.667H8.58a19.268,19.268,0,0,0-.163,2.333A19.268,19.268,0,0,0,8.58,16Zm.957,2.333H9.035a18.257,18.257,0,0,0,1.61,4.153,9.318,9.318,0,0,1-5.052-4.153ZM9.035,9H5.593a9.318,9.318,0,0,1,5.052-4.153A18.257,18.257,0,0,0,9.035,9Zm4.632,13.953a16.435,16.435,0,0,1-2.228-4.62H15.9A16.435,16.435,0,0,1,13.667,22.953ZM16.4,16h-5.46a17.165,17.165,0,0,1-.187-2.333,17.016,17.016,0,0,1,.187-2.333H16.4a17.016,17.016,0,0,1,.187,2.333A17.165,17.165,0,0,1,16.4,16Zm.292,6.487a18.257,18.257,0,0,0,1.61-4.153H21.74A9.368,9.368,0,0,1,16.688,22.487ZM18.753,16a19.268,19.268,0,0,0,.163-2.333,19.268,19.268,0,0,0-.163-2.333H22.7A9.126,9.126,0,0,1,22.7,16Z",
    transform: "translate(0.333 0.333)",
    fill: "#f60"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.275fb18ac68a0db0c8fc67d0eaaf722c.svg";
export { ForwardRef as ReactComponent };